import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {
	Link
} from 'react-router-dom';
import Loader from '../../components/Loader';
import axiosInstance from '../../utils/api';

type Props = {}

interface SensorInterface {
    id: number;
    serial: string;
    date_pucharse: string;
    node: string;
    name: string;
}

const SensorList = (props: Props) => {
    const title = "Sensor"
    const [loading, setLoading] = useState(false)
    const [sensors, setSensors] = useState<Array<SensorInterface>>([])

    useEffect(() => {
        getDateList()
    }, [])

    function getDateList() {
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/internal/operations/v1/sensor").then(res=>{
            setLoading(false)
            setSensors(res.data)
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }

    function handleDelete(id:string) {
        if (!window.confirm("Are you sure you want to delete record?")) return

        setLoading(true)
        axiosInstance.delete(`https://api.cl-ds.com/internal/operations/v1/sensor/${id}/`).then(res=>{
            console.log(11, res)
            setLoading(false)
            alert(res.data.message)
            getDateList()
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }
    

    return (
            <div className="col-12">
            {loading && ( <Loader/> )}

                <div className="card">
                    <div className="card-body">
                        <div className="row px-2" style={{display:"grid", gridTemplateColumns:"1fr 1fr"}}>
                            <h5 className="card-title">{title} List</h5>
                            <div style={{display:"flex", justifyContent:"end", alignSelf:"center"}}>
                                
                                <Link to="/sensor/add" >
                                    <button type="button" className="btn btn-outline-info">Create</button>
                                </Link>
                            </div>

                        </div>


                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Serial</th>
                                    <th scope="col">Date Purchase</th>
                                    {/* <th scope="col">Node</th> */}
                                    <th scope="col">Name</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sensors.map( (sensor, index) => {

                                    return (
                                        <tr key={index}>
                                            <th scope="row">{sensor.serial}</th>
                                            <td>{sensor.date_pucharse}</td>
                                            {/* <td>{sensor.node}</td> */}
                                            <td>{sensor.name}</td>
                                            <td>
                                                <Link to={`/sensor/edit/${sensor.id}`} >
                                                    <button type="button" className="btn btn-outline-info"><i className="bi bi-pencil"></i></button>
                                                </Link>
                                                <button type="button" className="btn btn-outline-danger mx-1" onClick={()=>{handleDelete(sensor.id.toString())}}><i className="bi bi-trash"></i></button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    

                    </div>
                </div>

            </div>

    )
}

export default SensorList